module.exports = __webpack_public_path__ + "img/supportwildlife.870d05e5.jpg";